export default function GoogleLogo() {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.94 13.2708C24.94 12.4258 24.8642 11.6133 24.7233 10.8333H13.5V15.4429H19.9133C19.6371 16.9325 18.7975 18.1946 17.5354 19.0396V22.0296H21.3867C23.64 19.955 24.94 16.9 24.94 13.2708Z"
        fill="#4285F4"
      />
      <path
        d="M13.5 24.9167C16.7175 24.9167 19.415 23.8496 21.3867 22.0296L17.5354 19.0396C16.4683 19.7546 15.1033 20.1771 13.5 20.1771C10.3962 20.1771 7.76916 18.0808 6.83208 15.2642H2.85083V18.3517C4.81166 22.2463 8.84166 24.9167 13.5 24.9167Z"
        fill="#34A853"
      />
      <path
        d="M6.83206 15.2642C6.59373 14.5492 6.45831 13.7854 6.45831 13C6.45831 12.2146 6.59373 11.4508 6.83206 10.7358V7.64833H2.85081C2.01665 9.30893 1.58258 11.1417 1.58331 13C1.58331 14.9229 2.04373 16.7429 2.85081 18.3517L6.83206 15.2642Z"
        fill="#FBBC05"
      />
      <path
        d="M13.5 5.82292C15.2496 5.82292 16.8204 6.42417 18.0554 7.605L21.4733 4.18709C19.4096 2.26417 16.7121 1.08334 13.5 1.08334C8.84166 1.08334 4.81166 3.75375 2.85083 7.64834L6.83208 10.7358C7.76916 7.91917 10.3962 5.82292 13.5 5.82292Z"
        fill="#EA4335"
      />
    </svg>
  );
}
